import { useAppDispatch, useAppSelector } from 'app/hooks';
import { MOBILE_ORDER_DISPLAY_ONLY_EDITED } from 'features/Store/constants';
import { COLUMN_WIDTH } from 'features/Store/pages/StoreSettingDetailPage';
import {
  selectStoreSettingDetailDisplayType,
  selectStoreSettingDetailExpandAll,
  selectStoreSettingEditedMenuBookIds,
  storeSettingDetailActions,
} from 'features/Store/storeSettingDetailSlice';
import { countSubMenuGroupHasEditedMObileOrderDisplayFlg, getIsExpandStatus } from 'features/Store/utils';
import React, { useEffect, useState } from 'react';
import { MINUS_TEXT, PLUS_TEXT } from 'utils';
import { Course, Genre, Menu, MenuBook, SubGenre, SubMenuGroup } from '../../models';

export interface SubMenuGroupRowCollapseProps {
  menuBook: MenuBook;
  course?: Course;
  genre: Genre;
  subgenre: SubGenre;
  menu: Menu;
  subMenuGroup: SubMenuGroup;
  children?: React.ReactNode;
}

function SubMenuGroupRow({
  menuBook,
  course,
  genre,
  subgenre,
  menu,
  subMenuGroup,
  children,
}: SubMenuGroupRowCollapseProps) {
  const dispatch = useAppDispatch();
  const isExpand = useAppSelector(selectStoreSettingDetailExpandAll);
  const editedMenuBookIds = useAppSelector(selectStoreSettingEditedMenuBookIds);
  const displayType = useAppSelector(selectStoreSettingDetailDisplayType);

  const [open, setOpen] = useState(getIsExpandStatus(menuBook, editedMenuBookIds, isExpand));

  let pathId = `${menuBook.id}-${genre.id}-${subgenre.id}-${menu.id}-${subMenuGroup.id}`;
  if (course) {
    pathId = `${menuBook.id}-${course.id}-${genre.id}-${subgenre.id}-${menu.id}-${subMenuGroup.id}`;
  }

  useEffect(() => {
    const btnExpandElem = document.querySelector(`#submenugroup-${pathId}-row .dan-btn-expand`) as HTMLButtonElement;
    function handleBtnExpandElemClick(event: MouseEvent) {
      event.stopPropagation();
      setOpen(!open);
      dispatch(storeSettingDetailActions.setExpandAll(undefined));
      btnExpandElem.innerHTML = !open ? MINUS_TEXT : PLUS_TEXT;
      btnExpandElem?.setAttribute('aria-expanded', !open ? 'true' : 'false');
    }

    if (btnExpandElem) {
      btnExpandElem.addEventListener('click', handleBtnExpandElemClick);
    }

    return () => {
      if (btnExpandElem) {
        btnExpandElem.removeEventListener('click', handleBtnExpandElemClick);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, displayType]);

  useEffect(() => {
    if (isExpand !== undefined) {
      setOpen(getIsExpandStatus(menuBook, editedMenuBookIds, isExpand));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpand]);

  const countTotalEditedMobileOrderDisplay = countSubMenuGroupHasEditedMObileOrderDisplayFlg(subMenuGroup);
  if (displayType === MOBILE_ORDER_DISPLAY_ONLY_EDITED && countTotalEditedMobileOrderDisplay === 0) {
    return null;
  }

  return (
    <>
      <div id={`submenugroup-${pathId}-row`} className="dan-tr content-visibility-auto">
        <div
          className="dan-td"
          style={{
            width: `${COLUMN_WIDTH.slice(0, 7).reduce((sum, width) => sum + width, 0)}%`,
          }}
        ></div>
        <div className="dan-td" style={{ width: `${COLUMN_WIDTH[7]}%` }}>
          <button
            className="dan-btn-expand"
            tabIndex={-1}
            aria-controls={`submenugroup-${pathId}-content`}
            aria-expanded={open}
          >
            {open ? MINUS_TEXT : PLUS_TEXT}
          </button>
          <span>{subMenuGroup.name}</span>
        </div>
        <div className="dan-td justify-content-center" style={{ width: `${COLUMN_WIDTH[8]}%` }}>
          {subMenuGroup.cd}
        </div>
        <div
          className="dan-td"
          style={{
            width: `${COLUMN_WIDTH.slice(9, 17).reduce((sum, width) => sum + width, 0)}%`,
          }}
        ></div>
      </div>
      <div style={{ contentVisibility: open ? 'auto' : 'hidden' }}>
        <div id={`submenugroup-${pathId}-content`}>{children}</div>
      </div>
    </>
  );
}

export default SubMenuGroupRow;
